import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { PhotoCollectionDto } from '../../../models/trofaco/photoCollectionDto';
import { PhotoDto } from '../../../models/trofaco/photoDto';
import { defer, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhotoCollectionService {

    constructor(private requestService: RequestService) {
    }


    async saveDocument(siteId: string, document: PhotoCollectionDto): Promise<string> {
        let data = {
            title: document.title,
            description: document.description,
            date: document.date
        };
        if (document.id) {
            await this.requestService.patch('photoCollection/update-planting-site-document',
                {documentId: document.id, ...data});
            return document.id;
        } else {
            let result = await this.requestService.post('photoCollection/create-planting-site-document',
                {plantingSiteId: siteId, ...data});
            return result.data;
        }
    }

    async deletDocument(id: string): Promise<string> {
        let result = await this.requestService.delete('photoCollection/delete-planting-site-document/' + id);
        return result.data;
    }

    async uploadCollectionPhoto(file: File, collectionId: string, lat: number, lon: number): Promise<PhotoDto> {
        let formData = new FormData();
        formData.append('photo', file, file.name);
        formData.append('photoCollectionId', collectionId);
        formData.append('lat', lat.toString());
        formData.append('lon', lon.toString());
        let result = await this.requestService.post('photoCollection/add-photo-to-collection', formData);
        return result.data;
    }

    setCollectionThumbnail(collectionId: string, photoId: string) {
        return this.requestService.patch(`photoCollection/set-thumbnail/${collectionId}?photoId=${photoId}`, null);
    }

    updatePhoto(photo: PhotoDto) {
        return this.requestService.post('photoCollection/update-photo', {photoId: photo.id, lat: Number(photo.lat), lon: Number(photo.lon)});
    }

    deletePhoto(photoId: string, plantingSiteId: string) {
        return this.requestService.delete(`photoCollection/delete-photo/${photoId}?plantingSiteId=${plantingSiteId}`);
    }

     getAllTitles(): Observable<string[]> {
        return defer(async () => {
            let result = await this.requestService.get('photoCollection/titles');
            return result.data;
        });
    }
}
